import React from "react";
import { Box, Button, Typography } from "@mui/material";

/**
 * Shown above the availability fields when a track is being created for a
 * theme. Dates are locked to the theme's until the admin opts out.
 */
const ThemeContextBanner = ({ themeContext, kind = "song", datesLocked, onUnlock }) => {
  if (!themeContext?.themeId) return null;
  return (
    <Box
      sx={{
        mb: 1.5,
        p: 1.25,
        borderRadius: "6px",
        backgroundColor: "#f4f6fb",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        Creating for theme {themeContext.title || "this theme"}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
        Dates match the theme and the {kind} is linked to it when saved. Stickers
        above start from the theme; remove any that should not be on this {kind}.
      </Typography>
      {datesLocked && (
        <Button
          size="small"
          onClick={onUnlock}
          sx={{ textTransform: "none", px: 0, mt: 0.5 }}
        >
          Edit dates anyway
        </Button>
      )}
    </Box>
  );
};

export default ThemeContextBanner;
